import React from 'react';
import { Typography, Grid, Link, Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import config from '../../config/config.json';

const useStyles = makeStyles((theme) => ({
    getMethod: {
        color: '#0cbb52',
        textTransform: 'uppercase',
    },
}));

export default function (props) {
    const classes = useStyles();
    return (
        <>
            <Typography variant="h6" color="initial">
                <code>
                    Alertas
                </code>
            </Typography>
            <br />

            <Typography variant="subtitle2" color="initial">
                Alertas meteorológicas
            </Typography>
            <br />

            <Grid container spacing={1}>
                <Grid item sm={1}>
                    <Typography variant="subtitle1" className={classes.getMethod}>GET</Typography>
                </Grid>
                <Grid item sm={8}>
                    <Typography variant="subtitle1" className="endPoint">/alertas</Typography>
                </Grid>
                <Grid item sm={3}>
                    <Typography variant="subtitle1" color="primary">
                        <Link href={`${config.apiBaseUrl}/alertas`} target="_blank">
                            Pruébalo
                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.7928 8.50002L8.64637 12.6465L9.35348 13.3536L14.707 8.00004L9.35348 2.64648L8.64637 3.35359L12.7928 7.50002H3V8.50002H12.7928Z" fill="#3f51b5">
                                </path>
                            </svg>
                        </Link>
                    </Typography>
                </Grid>
            </Grid>
            <br />

            <pre>
                {config.apiBaseUrl}/alertas
            </pre>
            <br />

            <Typography paragraph variant="body2">
                Devuelve una lista de alertas emitidas por la entidad correspondientes a la última fecha de emisión, donde cada alerta corresponde a un municipio.
                La respuesta es una lista de objetos donde cada uno de ellos representa una alerta para un municipio determinado.
            </Typography>
            <br />

            <Typography variant="h6" color="initial">
                Ejemplo: <br /> {/* Ejemplo de respuesta */}
                {/* con un Tabs de mui mostrar [cuerpo, cabecera] */}
            </Typography>
            <br />
            <pre>
                [
                <div>{`{`}</div>
                <div><span className="pre-key">"alerta"</span>: <span className="pre-value">"Derrumbes o Deslizamientos de Tierra",</span></div>
                <div><span className="pre-key">"riesgo"</span>: <span className="pre-value">"Bajo",</span></div>
                <div><span className="pre-key">"municipio"</span>: <span className="pre-value">"Songo la Maya",</span></div>
                <div><span className="pre-key">"descripcion"</span>: <span className="pre-value">"descripcion",</span></div>
                <div><span className="pre-key">"fecha"</span>: <span className="pre-value">"2021-02-11",</span></div>
                <div><span className="pre-key">"meteorologo"</span>: <span className="pre-value">"Pepe Sosa Martínez"</span></div>
                <div>{`}`},</div>
                <div>{`{`}</div>
                <div><span className="pre-key">"alerta"</span>: <span className="pre-value">"Incendios",</span></div>
                <div><span className="pre-key">"riesgo"</span>: <span className="pre-value">"Alto",</span></div>
                <div><span className="pre-key">"municipio"</span>: <span className="pre-value">"Contramaestre",</span></div>
                <div><span className="pre-key">"descripcion"</span>: <span className="pre-value">"incendio",</span></div>
                <div><span className="pre-key">"fecha"</span>: <span className="pre-value">"2021-02-11",</span></div>
                <div><span className="pre-key">"meteorologo"</span>: <span className="pre-value">"Pepe Sosa Martínez"</span></div>
                <div>{`}`},</div>
                <div>{`{`}</div>
                <div><span className="pre-key">"alerta"</span>: <span className="pre-value">"Intensas Lluvias",</span></div>
                <div><span className="pre-key">"riesgo"</span>: <span className="pre-value">"Medio",</span></div>
                <div><span className="pre-key">"municipio"</span>: <span className="pre-value">"Guamá",</span></div>
                <div><span className="pre-key">"descripcion"</span>: <span className="pre-value">"Intensas lluvias en el papayo",</span></div>
                <div><span className="pre-key">"fecha"</span>: <span className="pre-value">"2021-02-11",</span></div>
                <div><span className="pre-key">"meteorologo"</span>: <span className="pre-value">"Pepe Sosa Martínez"</span></div>
                <div>{`}`},</div>
]
            </pre>

            <Typography variant="h6" color="initial">
                Cada objeto esta formado por:
            </Typography>
            <br />

            <table className="table table-striped table-bordered table-hover">
                <thead>
                    <tr>
                        <th>Campo</th>
                        <th>Tipo</th>
                        <th>Descripción</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>alerta</td>
                        <td>string</td>
                        <td>Representa el tipo de alerta</td>
                    </tr>
                    <tr>
                        <td>riesgo</td>
                        <td>string</td>
                        <td>Riesgo de la alerta (Bajo, Medio, Alto)</td>
                    </tr>
                    <tr>
                        <td>municipio</td>
                        <td>string</td>
                        <td>Municipio para el cual se emite la alerta</td>
                    </tr>
                    <tr>
                        <td>descripcion</td>
                        <td>string</td>
                        <td>Una breve descripcion de los posibles daños</td>
                    </tr>
                    <tr>
                        <td>fecha</td>
                        <td>date</td>
                        <td>Fecha de emisión de la alerta</td>
                    </tr>
                    <tr>
                        <td>meteorologo</td>
                        <td>string</td>
                        <td>Meteorologo que emite la alerta</td>
                    </tr>
                </tbody>
            </table>
            <br />

            {/* Possible errors: <br />
            Error code, 	Description <br />
            401 Unauthorized 	The accessToken is invalid, lacks the listPublications scope or has been revoked. <br />
            403 Forbidden 	The request attempts to list publications for another user. <br /> */}


        </>
    )
}